module.exports = __webpack_public_path__ + "static/top-25-2021-f97efae3c76a531ad3dc6fd1b97f0537.png";